export default __webpack_public_path__ + "static/media/stdm.b8d4092e.png";